// src/store/api/payment.js

import api from './base';

// Initiates PhonePe payment — returns { redirectUrl, orderId, amount, transactionId }
export const createPaymentOrder = async (paymentData) => {
  const response = await api.post('/payment/create-order', paymentData);
  return response.data;
};

// Verifies PhonePe payment after redirect — backend polls PhonePe status API
export const verifyPayment = async ({ orderId }) => {
  const response = await api.post('/payment/verify', { orderId });
  return response.data;
};

export const cancelPayment = async (orderId, reason) => {
  const response = await api.post('/payment/cancel', {
    orderId,
    reason: reason || 'Payment cancelled by user'
  });
  return response.data;
};